import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Skeleton, Avatar } from 'antd'
import { AreaChartOutlined, ContactsFilled } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { fetchMoreData, searchProgramServiceRows } from 'utils'
import { config } from 'configs'
import { useHistory } from 'react-router-dom'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { AiFillEye } from 'react-icons/ai'
import {
  serviceActions,
  useServiceSelector,
} from 'store/serviceSlice/serviceReducer'
import {
  getOrganizationServices,
  updateServiceStatus,
} from 'store/serviceSlice/serviceActions'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Can } from 'permissions'

function InactiveList({ searchText }) {
  const dispatch = useDispatch()
  const history = useHistory()

  const { organization } = useAuthSelector()
  const { loading, inactive } = useServiceSelector()

  const filteredInactive = inactive.filter(
    (service) => service?.OrganizationId === organization?.id,
  )

  const [current, setCurrent] = useState([])

  const searchedData = searchProgramServiceRows(filteredInactive, searchText)

  useEffect(() => {
    setCurrent(searchedData.slice(0, config.itemFirstLoad))
    // eslint-disable-next-line
  }, [filteredInactive, searchText])

  const fetchData = () => {
    dispatch(getOrganizationServices(organization?.id))
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, [])

  const handleServiceSelected = (e, service) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(serviceActions.setService(null))
    history.push(`services/${service.ServiceId}`)
  }

  const handleUpdate = (service) => {
    dispatch(
      updateServiceStatus(service?.ServiceId, service?.ActiveInd, fetchData),
    )
  }

  return (
    <Skeleton loading={loading} active paragraph={{ rows: 18 }}>
      <div className="t-flex t-flex-col t-justify-between t-h-full">
        <InfiniteScroll
          dataLength={current.length}
          next={() => fetchMoreData(current, setCurrent, searchedData)}
          hasMore={current.length < searchedData.length}
          loader={
            <div className="t-flex t-justify-center t-items-center">
              {/* <Spin /> */}
            </div>
          }
        >
          <Row gutter={[24, 24]}>
            {current.length === 0 && (
              <div className="t-h-96 t-flex t-justify-center t-items-center t-w-full">
                <div className="t-flex t-flex-col t-items-center t-space-y-2">
                  <AreaChartOutlined
                    style={{ fontSize: '2rem' }}
                    className="t-text-secondary-100"
                  />
                  <p>No records found</p>
                </div>
              </div>
            )}
            {current.map((item, index) => (
              <Col span={24} lg={8} className="mb-24" key={index}>
                <Card
                  bodyStyle={{ paddingTop: '14px' }}
                  bordered={false}
                  className="card-project-2 header-solid t-cursor-pointer"
                  title={[
                    <Row gutter={[24, 24]} key={0}>
                      <Col span={4}>
                        <Avatar
                          src={<ContactsFilled />}
                          style={{
                            width: '25px',
                            height: '25px',
                            lineHeight: '74px',
                            borderRadius: '8px',
                            padding: '16px',
                            backgroundColor: config.colors.primary,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        />
                      </Col>
                      <Col span={16} className="t-overflow-hidden">
                        <h6 className="font-semibold mb-10 t-w-64 t-truncate">
                          {item.Title ? item.Title : 'No Title Found'}
                        </h6>
                      </Col>
                      <Can
                        I={config.actions.edit}
                        a={config.components.service}
                      >
                        <Col span={4} className="ml-auto pt-10">
                          <AiFillEye
                            fontSize="1.2rem"
                            className="t-cursor-pointer"
                            onClick={() => handleUpdate(item)}
                          />
                        </Col>
                      </Can>
                    </Row>,
                  ]}
                  onClick={(e) => handleServiceSelected(e, item)}
                >
                  <p className="t-truncate">
                    {item?.Description
                      ? item?.Description
                      : 'No Desription Found'}
                  </p>
                  <hr />
                  <div className="t-flex t-justify-end t-mt-2">
                    <Button
                      type="link"
                      size="small"
                      className="t-rounded-full"
                      onClick={(e) => handleServiceSelected(e, item)}
                    >
                      See More
                    </Button>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </InfiniteScroll>
      </div>
    </Skeleton>
  )
}

export { InactiveList }
